module.exports = __webpack_public_path__ + "img/no_profile_picture.ffb7571e.png";